import { MRT_Icons } from "material-react-table";

const DragIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    className="MuiTable-dragIcon"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 9h16.5m-16.5 6.75h16.5"
    />
  </svg>
);

export const tableIcons: Partial<MRT_Icons> = {
  DragHandleIcon: () => <DragIcon />,
};
